import React from "react";
import PropTypes from "prop-types";
import { calculateCallsTotals } from "./reportHelpers";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const AgentTextsTotalRow = ({ reportData }) => (
  <TR className="tw-bg-white tw-sticky tw-bottom-0">
    <TD>
      <strong>Totals</strong>
    </TD>
    <TD>
      <strong>{calculateCallsTotals(reportData, "text_report_agent_total_lead_count")}</strong>
    </TD>
    <TD>
      <strong>{calculateCallsTotals(reportData, "text_report_lead_text_count")}</strong>
    </TD>
    <TD>
      <strong>{calculateCallsTotals(reportData, "text_report_non_lead_text_count")}</strong>
    </TD>
    <TD>
      <strong>{calculateCallsTotals(reportData, "text_report_total_texts")}</strong>
    </TD>
    <TD>
      <strong>{calculateCallsTotals(reportData, "text_report_total_texts_recd")}</strong>
    </TD>
    <TD>
      <strong>{calculateCallsTotals(reportData, "text_report_total_text_count")}</strong>
    </TD>
  </TR>
);

AgentTextsTotalRow.propTypes = {
  reportData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default AgentTextsTotalRow;
